module.exports = __webpack_public_path__ + "media/images/emblems/Alchenstorf-coat_of_arms-1f883499dfe08b0f34cb4501fb23df77.svg";